import React, {Component} from 'react';
//import {ga} from 'react-ga';

import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    TelegramShareButton,
    WhatsappShareButton,
    PinterestShareButton,
    RedditShareButton,
    TumblrShareButton,
    ViberShareButton,
    EmailShareButton,
} from 'react-share'; // В этой либе есть еще разные соцсети, но надо проработать, чтобы не было слишком громоздко

import {
    FacebookIcon,
    TwitterIcon,
    TelegramIcon,
    WhatsappIcon,
    LinkedinIcon,
    PinterestIcon,
    RedditIcon,
    TumblrIcon,
    ViberIcon,
    EmailIcon
} from 'react-share';

/*
import {
    FacebookShareCount,
    PinterestShareCount,
    VKShareCount,
    OKShareCount,
    RedditShareCount,
    TumblrShareCount,
} from 'react-share';
*/

class SocialButtons extends Component {
    constructor(props) {
        super(props);
    }

    onClick(buttonType) {
        //ga('send', 'event', 'Share Click', buttonType);
    }

    render() {
        let shareUrl = typeof window !== 'undefined' ? window.location.href : '';
        let size = 32;
        let round = true;

        return (
            <div style={{...styles.root, ...this.props.style}}>
                {/*<FacebookShareButton quote={'https://upload.wikimedia.org/wikipedia/commons/3/3a/Cat03.jpg'} style={styles.button} url={shareUrl}><FacebookIcon size={size} round={round} /></FacebookShareButton>*/}
                <FacebookShareButton beforeOnClick={this.onClick.bind(this, 'facebook')} style={styles.button} url={shareUrl}><FacebookIcon size={size} round={round} /></FacebookShareButton>
                <LinkedinShareButton beforeOnClick={this.onClick.bind(this, 'linkedin')} style={styles.button} url={shareUrl}><LinkedinIcon size={size} round={round} /></LinkedinShareButton>
                <TwitterShareButton beforeOnClick={this.onClick.bind(this, 'twitter')} style={styles.button} url={shareUrl}><TwitterIcon size={size} round={round} /></TwitterShareButton>
                <TelegramShareButton beforeOnClick={this.onClick.bind(this, 'telegram')} style={styles.button} url={shareUrl}><TelegramIcon size={size} round={round} /></TelegramShareButton>
                <WhatsappShareButton beforeOnClick={this.onClick.bind(this, 'whatsapp')} style={styles.button} url={shareUrl}><WhatsappIcon size={size} round={round} /></WhatsappShareButton>
                <PinterestShareButton beforeOnClick={this.onClick.bind(this, 'pinterest')} style={styles.button} url={shareUrl}><PinterestIcon size={size} round={round} /></PinterestShareButton>
                <RedditShareButton beforeOnClick={this.onClick.bind(this, 'reddit')} style={styles.button} url={shareUrl}><RedditIcon size={size} round={round} /></RedditShareButton>
                <TumblrShareButton beforeOnClick={this.onClick.bind(this, 'tumblr')} style={styles.button} url={shareUrl}><TumblrIcon size={size} round={round} /></TumblrShareButton>
                <ViberShareButton beforeOnClick={this.onClick.bind(this, 'viber')} style={styles.button} url={shareUrl}><ViberIcon size={size} round={round} /></ViberShareButton>
                <EmailShareButton beforeOnClick={this.onClick.bind(this, 'email')} style={styles.button} url={shareUrl}><EmailIcon size={size} round={round} /></EmailShareButton>

                {/*
                Facebook
                <FacebookShareCount url={shareUrl} />
                VK
                <VKShareCount url={shareUrl} />
                Pinterest
                <PinterestShareCount url={shareUrl} />
                OK
                <OKShareCount url={shareUrl} />
                Reddit
                <RedditShareCount url={shareUrl} />
                Tumblr
                <TumblrShareCount url={shareUrl} />*/}
            </div>
        );
    }
}

const styles = {
    root: {
        //width: '60px'
    },
    button: {
        display: 'inline-block',
        marginRight: '5px',
        cursor: 'pointer'
    }
};

export default SocialButtons;